export type TicketStatus = 'open' | 'in_progress' | 'resolved' | 'closed';

export type TicketCategory =
  | 'script_upload'
  | 'episode_processing'
  | 'asset_analysis'
  | 'base_image'
  | 'shot_generation'
  | 'state_image_prompt'
  | 'video_generation'
  | 'account_credits'
  | 'other';

// TICKET_STATUS_LABEL and CATEGORY_LABEL moved to i18n: tickets.status.* and tickets.category.*

export const ALL_CATEGORIES: TicketCategory[] = [
  'script_upload', 'episode_processing', 'asset_analysis', 'base_image',
  'shot_generation', 'state_image_prompt', 'video_generation', 'account_credits', 'other',
];

export const CATEGORY_RELATED_TYPE: Record<TicketCategory, 'project' | 'episode' | 'shot' | 'none' | 'optional'> = {
  script_upload: 'project',
  episode_processing: 'episode',
  asset_analysis: 'project',
  base_image: 'project',
  shot_generation: 'episode',
  state_image_prompt: 'shot',
  video_generation: 'shot',
  account_credits: 'none',
  other: 'optional',
};

export interface TicketAttachment {
  type: 'image' | 'video';
  url: string;
  fileName: string;
  size: number;
}

export interface TicketMessage {
  id: string;
  ticketId: string;
  authorId: string;
  authorName: string;
  authorRole: 'user' | 'admin' | 'system';
  content: string;
  attachments?: string; // JSON string
  isSystemEvent: boolean;
  systemEventType?: string;
  createdAt: string;
}

export interface Ticket {
  id: string;
  userId: string;
  userName: string;
  category: TicketCategory;
  title: string;
  projectId?: string;
  projectName?: string;
  relatedType?: string;
  relatedId?: string;
  relatedName?: string;
  status: TicketStatus;
  contextSnapshot?: string;
  lastActivityAt: string;
  resolvedAt?: string | null;
  closedAt?: string | null;
  createdAt: string;
  messages?: TicketMessage[];
}

export interface TicketSummary {
  open: number;
  inProgress: number;
  awaitingUserReply: number;
}
